// @ts-nocheck
/* eslint-disable */ /* GENERATED USING build-GemIcons.ts - DO NOT MODIFY */ import { ReactComponent as LogoLivy } from '../../../assets/images/Logos/logo-livy.svg?react';
import { withLogoClass } from '../../withLogoClass';
export const LogoLivyIcon = /* @__PURE__ */ withLogoClass(LogoLivy);
